<template lang='pug'>
.item-containerr
    .topTitle(v-if="topTitle") {{topTitle}}
    .item
        img.big(v-src="img" @click="push()")
        .bottom(v-if="type!='shoucang'") {{name}}
        .bottom2(v-show="type=='shoucang'")
            .left
                img(src="@/assets/imgs/collect-white@3x.png" v-if="!result")
                img(src="@/assets/imgs/icon-collected-white@3x.png" v-if="result")
                .text(@click="shoucang") 收藏
            .right
                img(src="@/assets/imgs/view-white@3x.png")
                .text(@click="push()") 查看
</template>

<script>
import {addBookmark,deleteBookmark,checkMember} from '@/service/member'
import { mapState } from 'vuex'
export default {
    props:['name',"img","topTitle","type","id"]
,
    data(){
        return {
            data:[],
            introduceDetail:[],
            result:false,
            params:{},
        }
    },
    computed:{
        ...mapState(['memberInfo','bookMarks'])
    },
    methods:{
        async shoucang(){
            const {VUE_APP_MEMBER_FORMID,VUE_APP_FORM} =window.env
            let isMember =await checkMember(true)
            if(!isMember){
               window.location.href=`${VUE_APP_FORM}${VUE_APP_MEMBER_FORMID}?redirect=${encodeURIComponent(window.location.href)}`
            }
            this.params={
                // introduceName:this.topTitle
                marketId: this.id
            }
            if(this.result){
                await deleteBookmark(this.result.id)
                await this.$store.dispatch('getBookmarks',true)
                this.data=this.$store.state.bookMarks
                await this.initData()
            }else{
                await addBookmark({
                    detail:{
                        type:'content',
                        bigName:'产品介绍',
                        smallName:this.topTitle,
                        name:'introduceDetail',
                        params:this.params,
                        imga:this.img
                    },
                    name: this.topTitle,
                    url: window.location.href
                })
                 await this.$store.dispatch('getBookmarks',true)
                this.data=this.$store.state.bookMarks
                await this.initData()
            }
        },
        push(){
            if(this.type=='shoucang'){
                this.$router.push({name:'introduceDetail',params:{
                introduceId:this.id
            }})
            }
            
        },
        async initData() {
            this.introduceDetail=[],
            this.data.forEach(val=>{
                if(val.detail.type=='content'){
                    if(val.detail.name=='introduceDetail'){
                        this.introduceDetail.push(val)
                    }
                }
            })
            this.result=this.introduceDetail.find(val=>{
                return ((val.detail.bigName=='产品介绍')&&(val.detail.smallName==this.topTitle))
            })
        }
    },
    async created() {
             if(this.bookMarks){
                this.data=this.bookMarks
                await this.initData()
            }
        
    }
}
</script>

<style scoped lang='less'>
.item-containerr{
    .topTitle{
        font-size: 0.6rem;
        line-height: 0.9rem;;
        margin-bottom:0.4rem;
        text-align: center;
        color:#07448a;
        width:7.8rem;
    }
.item{
        // background-repeat: no-repeat;
        // background-size: 100%;
        // background-position: 0 -1.44rem;
        width:7.8rem;
        height:5.6rem;
        position: relative;
        border-radius: 0.3rem;
        overflow: hidden;
        .big{
            width: 100%;
            height:100%;
            border-radius: 0.3rem;
            display: block;
        }
        .bottom{
            width:100%;
            height: 1.3rem;
            color:white;
            line-height: 1.3rem;
            position: absolute;
            bottom: 0;
            border-radius: 0rem 0rem 0.3rem 0.3rem;
            text-align: center;
            background:rgba(33,156,220,0.8)

        }
        .bottom2{
            background:rgba(33,156,220,0.8);
            padding-left:0.5rem;
            padding-right: 0.45rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width:100%;
            height: 1.3rem;
            color:white;
            border-radius: 0rem 0rem 0.3rem 0.3rem;
            position: absolute;
            bottom: 0;
            
            .left,.right{
                display: flex;
                align-items: center;
                position: relative;
                z-index: 999;
            }
            img{
                height:0.6rem;
                width: 0.6rem;
                margin-right: 0.25rem;
                
            }
            .text{
                font-size: 0.6rem;
                line-height: 0.6rem;
            }
        }
    }
}

</style>